<div class="se-wrap">

  <div class="se-header">
    <button class="se-back-btn" (click)="cancel()">← Cancelar</button>
    <h2 class="se-header__title">{{ editMode ? 'Editar publicación' : 'Nueva publicación' }}</h2>
  </div>

  <div *ngIf="errorMessage" class="se-error">{{ errorMessage }}</div>

  <div *ngIf="loading" class="se-loading">
    <div class="se-spinner"></div>
    <span>Cargando...</span>
  </div>

  <div *ngIf="!loading" class="se-grid">

    <!-- ── Columna izquierda: contenido ───────────────────────── -->
    <div class="se-card">

      <div class="se-field">
        <div class="se-field__header">
          <label class="se-label">Contenido del post</label>
          <button class="se-ai-btn" (click)="showAiPanel = !showAiPanel">
            ✨ {{ showAiPanel ? 'Ocultar IA' : 'Generar con IA' }}
          </button>
        </div>

        <div *ngIf="showAiPanel" class="se-ai-panel">
          <textarea class="se-textarea"
                    [(ngModel)]="aiPrompt"
                    placeholder="Describe el post (ej. 'Anuncio de webinar sobre inversión el 15 de mayo')"
                    rows="2"></textarea>
          <div class="se-ai-controls">
            <select class="se-select" [(ngModel)]="aiTone">
              <option value="profesional">Profesional</option>
              <option value="casual">Casual</option>
              <option value="entusiasta">Entusiasta</option>
              <option value="informativo">Informativo</option>
            </select>
            <button class="se-btn se-btn--primary"
                    [disabled]="aiGenerating || !aiPrompt.trim()"
                    (click)="generateWithAi()">
              {{ aiGenerating ? 'Generando...' : 'Generar' }}
            </button>
          </div>
        </div>

        <textarea class="se-textarea se-textarea--main"
                  [(ngModel)]="content"
                  placeholder="Escribe aquí el texto del post..."
                  rows="9"></textarea>
        <div class="se-char-count">{{ content.length }} caracteres</div>
      </div>

      <div class="se-field">
        <label class="se-label">Imagen o video</label>
        <div *ngIf="!mediaPath" class="se-upload-zone">
          <input type="file" id="mediaFile" accept="image/*,video/*" (change)="onFileSelected($event)">
          <label for="mediaFile" class="se-upload-label">
            <span class="se-upload-label__icon">📎</span>
            <span>Seleccionar archivo <span class="se-upload-label__hint">(imagen o video)</span></span>
          </label>
        </div>
        <div *ngIf="mediaPath" class="se-media-preview">
          <span class="se-media-preview__type">{{ mediaType === 'VIDEO' ? '🎬 Video' : '🖼️ Imagen' }}</span>
          <span class="se-media-preview__name">{{ mediaFilename }}</span>
          <button class="se-link-btn" (click)="removeMedia()">Quitar</button>
        </div>
      </div>

      <div *ngIf="isYoutubeSelected" class="se-field se-youtube-fields">
        <label class="se-label">Configuración de YouTube</label>
        <input class="se-input" type="text" [(ngModel)]="youtubeTitle" placeholder="Título del video (obligatorio)">
        <textarea class="se-textarea"
                  [(ngModel)]="youtubeDescription"
                  placeholder="Descripción (opcional, si la dejas vacía se usará el texto del post)"
                  rows="3"></textarea>
      </div>

    </div>

    <!-- ── Columna derecha: opciones ──────────────────────────── -->
    <div class="se-sidebar">

      <div class="se-card">
        <div class="se-field se-field--last">
          <label class="se-label">Publicar en</label>
          <div class="se-networks">
            <label *ngFor="let net of ['INSTAGRAM','FACEBOOK','LINKEDIN','TIKTOK','TWITTER','YOUTUBE']"
                   class="se-net-row"
                   [class.se-net-row--disabled]="!isNetworkConnected($any(net))">
              <input type="checkbox"
                     [checked]="isNetworkSelected($any(net))"
                     [disabled]="!isNetworkConnected($any(net))"
                     (change)="toggleNetwork($any(net))">
              <span class="se-net-row__name">{{ networkLabels[net] }}</span>
              <span *ngIf="!isNetworkConnected($any(net))" class="se-net-row__tag">sin conectar</span>
            </label>
          </div>
        </div>
      </div>

      <div class="se-card">
        <div class="se-field se-field--last">
          <label class="se-label">Cuándo publicar</label>
          <label class="se-radio-row">
            <input type="radio" [(ngModel)]="publishMode" value="now" name="publishMode">
            <span>Publicar ahora</span>
          </label>
          <label class="se-radio-row">
            <input type="radio" [(ngModel)]="publishMode" value="scheduled" name="publishMode">
            <span>Programar</span>
          </label>
          <input *ngIf="publishMode === 'scheduled'"
                 type="datetime-local"
                 [(ngModel)]="scheduledAt"
                 class="se-input se-datetime">
        </div>
      </div>

      <div class="se-actions">
        <button class="se-btn se-btn--outline" (click)="cancel()">Cancelar</button>
        <button class="se-btn se-btn--primary" [disabled]="saving" (click)="save()">
          {{ saving ? 'Guardando...' : (publishMode === 'now' ? 'Publicar ahora' : 'Programar') }}
        </button>
      </div>

    </div>

  </div>
</div>
